@if (selectedLiveClass) {
<!-- Hero Section with Theme-Friendly Gradient Background -->
<div
  class="bg-gradient-to-br from-base-200 via-base-100 to-base-200/80 border-b border-base-300 relative pt-8 pb-10"
>
  <div class="container mx-auto px-4 relative z-10">
    <div class="flex flex-wrap -mx-4">
      <!-- Main Content Column -->
      <div class="w-full lg:w-4/6 px-4">
        <header class="subnav-hero-section">
          <!-- Title and Description with Better Typography -->
          <div class="mb-6">
            <h1
              class="text-base-content text-3xl md:text-4xl lg:text-5xl font-bold mb-4 leading-tight"
            >
              {{ selectedLiveClass.title }}
            </h1>
            <p
              class="text-base-content/70 text-lg md:text-xl max-w-3xl leading-relaxed"
            >
              {{ selectedLiveClass.details.descriptionSummary }}
            </p>
          </div>

          <!-- Stats Cards with Enhanced Design -->
          <div class="mt-8">
            <div
              class="daisy-card daisy-card-bordered bg-base-100 shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div class="daisy-card-body p-4">
                <div class="grid grid-cols-2 md:grid-cols-4 gap-6">
                  <!-- Enrollments Stat -->
                  <div
                    class="flex flex-col items-center text-center p-4 rounded-lg hover:bg-base-200/50 transition-colors duration-200"
                  >
                    <div
                      class="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-3 text-primary"
                    >
                      <i class="fa-solid fa-users text-xl"></i>
                    </div>
                    <p class="text-sm text-base-content/60 mb-1 font-medium">
                      Total Enrollments
                    </p>
                    <h4 class="text-2xl font-bold text-primary">
                      {{ selectedLiveClass.moreInfo?.totalSubscriptions || 0 }}
                    </h4>
                  </div>

                  <!-- Category Stat -->
                  <div
                    class="flex flex-col items-center text-center p-4 rounded-lg hover:bg-base-200/50 transition-colors duration-200"
                  >
                    <div
                      class="w-12 h-12 rounded-full bg-secondary/10 flex items-center justify-center mb-3 text-secondary"
                    >
                      <i class="fa-solid fa-book-open text-xl"></i>
                    </div>
                    <p class="text-sm text-base-content/60 mb-1 font-medium">
                      Group
                    </p>
                    <h4 class="text-2xl font-bold text-secondary">
                      {{ selectedLiveClass.subject }}
                    </h4>
                  </div>

                  <!-- Start Date Stat -->
                  <div
                    class="flex flex-col items-center text-center p-4 rounded-lg hover:bg-base-200/50 transition-colors duration-200"
                  >
                    <div
                      class="w-12 h-12 rounded-full bg-info/10 flex items-center justify-center mb-3 text-info"
                    >
                      <i class="fa-solid fa-calendar-day text-xl"></i>
                    </div>
                    <p class="text-sm text-base-content/60 mb-1 font-medium">
                      Starting From
                    </p>
                    <h4 class="text-lg font-bold text-info">
                      {{
                        selectedLiveClass.details.startDate | date: 'mediumDate'
                      }}
                    </h4>
                  </div>

                  <!-- Language Stat -->
                  <div
                    class="flex flex-col items-center text-center p-4 rounded-lg hover:bg-base-200/50 transition-colors duration-200"
                  >
                    <div
                      class="w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center mb-3 text-accent"
                    >
                      <i class="fa-solid fa-globe text-xl"></i>
                    </div>
                    <p class="text-sm text-base-content/60 mb-1 font-medium">
                      Language
                    </p>
                    <h4 class="text-2xl font-bold text-accent">
                      {{ selectedLiveClass.details.medium }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>

      <!-- Sidebar Column - Sticky on Desktop -->
      <div class="w-full lg:w-2/6 px-4 mt-8 lg:mt-0">
        <div class="lg:absolute lg:top-24 w-full lg:w-2/6">
          <div class="space-y-4">
            <!-- Course Card with Enhanced Design -->
            <div
              class="daisy-card daisy-card-bordered bg-base-100 shadow-xl hover:shadow-2xl transition-all duration-300"
            >
              <figure class="relative overflow-hidden">
                <img
                  [src]="
                    getResourcePath(
                      selectedLiveClass.settings.bannerImageResource
                    )
                  "
                  alt="{{ selectedLiveClass.title }}"
                  class="w-full h-48 object-cover hover:scale-105 transition-transform duration-500"
                />
                <div class="absolute top-4 right-4">
                  @if (selectedLiveClass.settings.price === 0) {
                  <span
                    class="daisy-badge daisy-badge-success daisy-badge-lg shadow-lg font-bold text-success-content"
                    >FREE</span
                  >
                  }
                </div>
              </figure>

              @if (selectedLiveClass.settings; as settings) {
              <div class="daisy-card-body p-6">
                <!-- Price Section with Better Typography -->
                <div class="mb-4">
                  @if (settings.price > 0) {
                  <div class="flex items-baseline gap-2">
                    <span class="text-4xl font-bold text-primary"
                      >LKR {{ settings.price }}</span
                    >
                    <span class="text-sm text-base-content/60 font-medium"
                      >/session</span
                    >
                  </div>
                  } @else {
                  <div class="text-4xl font-bold text-success">Free Course</div>
                  }
                </div>

                <!-- Payment Options with Modern Table Design -->
                @if (settings.price > 0) {
                <div class="mb-4 p-4 rounded-lg bg-base-200/50">
                  <p
                    class="text-sm font-semibold text-base-content/80 mb-3 flex items-center gap-2"
                  >
                    <i class="fa-solid fa-credit-card text-base-content/70"></i>
                    Payment Options
                  </p>
                  <div class="space-y-2">
                    <div
                      class="flex justify-between items-center p-3 bg-base-100 rounded-lg border border-base-300"
                    >
                      <span class="font-medium flex items-center gap-2">
                        Monthly
                        <black-tooltip
                          >This will be calculated based on the session count
                          per month</black-tooltip
                        >
                      </span>
                      <span class="font-bold text-primary"
                        >LKR
                        {{
                          selectedLiveClass.moreInfo?.paymentPlans?.monthly?.cost
                        }}</span
                      >
                    </div>
                    <div
                      class="flex justify-between items-center p-3 bg-base-100 rounded-lg border border-base-300"
                    >
                      <span class="font-medium">One-time</span>
                      <span class="font-bold text-primary"
                        >LKR
                        {{
                          selectedLiveClass.moreInfo?.paymentPlans?.oneTime?.cost
                        }}</span
                      >
                    </div>
                  </div>
                </div>
                } @if (settings.price === 0) {
                <div class="daisy-alert daisy-alert-success mb-4 shadow-sm text-success-content">
                  <i class="fa-solid fa-circle-check text-lg"></i>
                  <span class="font-medium"
                    >This live class is free to subscribe!</span
                  >
                </div>
                }

                <!-- Action Button with Better Design -->
                @if(hasValidSubscription(selectedLiveClass)) {
                <button
                  class="daisy-btn daisy-btn-block daisy-btn-primary daisy-btn-lg gap-2 shadow-lg hover:shadow-xl transition-all duration-300"
                  (click)="continueLearning()"
                >
                  <i class="fa-solid fa-play text-base"></i>
                  Continue Learning
                </button>
                } @else if (isPendingPayment()) {
                <div class="space-y-3">
                  <div
                    class="daisy-alert bg-warning/10 border border-warning/30 text-base-content text-xs py-3 px-3.5 flex items-start gap-2.5 shadow-sm rounded-box"
                  >
                    <div class="w-7 h-7 rounded-full bg-warning/20 flex items-center justify-center text-warning shrink-0 mt-0.5">
                      <i class="fa-solid fa-clock text-xs"></i>
                    </div>
                    <div>
                      <div class="font-bold text-sm text-base-content">
                        Payment Under Review
                      </div>
                      <div class="text-base-content/80 text-xs mt-0.5 leading-relaxed">
                        We received your payment. Your class access will unlock automatically once our team verifies your receipt.
                      </div>
                    </div>
                  </div>
                  <a
                    routerLink="/invoices"
                    class="daisy-btn daisy-btn-block daisy-btn-warning daisy-btn-md gap-2 shadow-sm"
                  >
                    <i class="fa-solid fa-receipt"></i>
                    <span>View Payment Status</span>
                  </a>
                </div>
                } @else {
                <button
                  class="daisy-btn daisy-btn-block daisy-btn-primary daisy-btn-lg gap-2 shadow-lg hover:shadow-xl transition-all duration-300"
                  (click)="subscribeNow()"
                >
                  <i class="fa-solid fa-ticket text-base"></i>
                  @if (settings.price > 0) {
                  <span>Subscribe Now</span>
                  } @else {
                  <span>Subscribe for Free</span>
                  }
                </button>
                }
              </div>
              }
            </div>

            <!-- Social Share Card -->
            <div class="daisy-card daisy-card-bordered bg-base-100 shadow-lg">
              <div class="daisy-card-body p-4">
                <black-social-share ngSkipHydration></black-social-share>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Main Content Area -->
<div class="container mx-auto px-4 py-8 md:py-12">
  <div class="flex flex-wrap -mx-4">
    <!-- Main Content Column -->
    <div class="w-full lg:w-4/6 px-4">
      <div class="space-y-8">
        <!-- About Section with Enhanced Design -->
        <section class="scroll-mt-24" id="about">
          <div class="flex items-center gap-3 mb-4">
            <div class="w-1 h-8 bg-primary rounded-full"></div>
            <h2 class="text-2xl md:text-3xl font-bold text-base-content">
              About the Course
            </h2>
          </div>
          <div
            class="daisy-card daisy-card-bordered bg-base-100 shadow-lg hover:shadow-xl transition-shadow duration-300"
          >
            <div class="daisy-card-body p-6 md:p-8">
              <div
                class="prose prose-neutral max-w-none text-base-content"
                [innerHTML]="selectedLiveClass.details.description"
              ></div>
            </div>
          </div>
        </section>

        <!-- What You'll Learn Section -->
        @if (selectedLiveClass.details.coverage?.length) {
        <section class="custom-list scroll-mt-24" id="learning">
          <div class="flex items-center gap-3 mb-4">
            <div class="w-1 h-8 bg-success rounded-full"></div>
            <h2 class="text-2xl md:text-3xl font-bold text-base-content">
              What You'll Learn
            </h2>
          </div>
          <div
            class="daisy-card daisy-card-bordered bg-base-100 shadow-lg hover:shadow-xl transition-shadow duration-300"
          >
            <div class="daisy-card-body p-6 md:p-8">
              <div class="grid md:grid-cols-2 gap-4">
                @for (item of selectedLiveClass.details.coverage; track item) {
                <div
                  class="flex items-start gap-3 p-3 rounded-lg hover:bg-base-200/50 transition-colors duration-200"
                >
                  <div class="flex-shrink-0 mt-0.5">
                    <i class="fa-solid fa-circle-check text-success text-base"></i>
                  </div>
                  <p class="text-base-content/80 leading-relaxed">{{ item }}</p>
                </div>
                }
              </div>
            </div>
          </div>
        </section>
        }

        <!-- Requirements Section -->
        @if (selectedLiveClass.details.requirements?.length) {
        <section class="custom-list scroll-mt-24" id="requirements">
          <div class="flex items-center gap-3 mb-4">
            <div class="w-1 h-8 bg-warning rounded-full"></div>
            <h2 class="text-2xl md:text-3xl font-bold text-base-content">
              Requirements
            </h2>
          </div>
          <div
            class="daisy-card daisy-card-bordered bg-base-100 shadow-lg hover:shadow-xl transition-shadow duration-300"
          >
            <div class="daisy-card-body p-6 md:p-8">
              <div class="space-y-3">
                @for (item of selectedLiveClass.details.requirements; track
                item) {
                <div
                  class="flex items-start gap-3 p-3 rounded-lg hover:bg-base-200/50 transition-colors duration-200"
                >
                  <div class="flex-shrink-0 mt-0.5">
                    <i class="fa-solid fa-circle-arrow-right text-warning text-base"></i>
                  </div>
                  <p class="text-base-content/80 leading-relaxed">{{ item }}</p>
                </div>
                }
              </div>
            </div>
          </div>
        </section>
        }

        <!-- Schedule Section with Modern Timeline -->
        <section class="scroll-mt-24" id="schedule">
          <div class="flex items-center gap-3 mb-4">
            <div class="w-1 h-8 bg-secondary rounded-full"></div>
            <h2 class="text-2xl md:text-3xl font-bold text-base-content">
              Class Schedule
            </h2>
          </div>
          <div class="space-y-4">
            @for (item of selectedLiveClass.meetings; track item; let first =
            $first; let last = $last) {
            <div
              class="daisy-card daisy-card-bordered bg-base-100 shadow-lg hover:shadow-xl transition-all duration-300 hover:translate-x-1"
            >
              <div class="daisy-card-body p-6">
                <div class="flex items-start gap-4">
                  <!-- Timeline Dot -->
                  <div class="flex flex-col items-center">
                    <div
                      class="w-12 h-12 rounded-full bg-secondary/10 flex items-center justify-center flex-shrink-0 text-secondary"
                    >
                      <i class="fa-solid fa-video text-lg"></i>
                    </div>
                    @if (!last) {
                    <div class="w-0.5 h-full bg-secondary/20 mt-2"></div>
                    }
                  </div>

                  <!-- Meeting Details -->
                  <div class="flex-1">
                    <div class="flex items-center gap-2 mb-2 flex-wrap">
                      <h3 class="text-xl font-bold text-base-content">
                        {{ item.name }}
                      </h3>
                      @if (isPendingPayment() && isPendingMeeting(item)) {
                        <span class="daisy-badge daisy-badge-sm daisy-badge-warning font-semibold text-warning-content gap-1">
                          <i class="fa-solid fa-clock text-xs"></i>
                          Verification Pending
                        </span>
                      } @else if (getSinglePassForMeeting(item); as pass) {
                        <button
                          type="button"
                          (click)="openPassModal(item)"
                          class="daisy-badge daisy-badge-sm daisy-badge-success font-bold text-success-content gap-1 cursor-pointer hover:opacity-90 transition-opacity"
                          title="Click to view Pass details"
                        >
                          <i class="fa-solid fa-ticket text-xs"></i>
                          Your Pass
                          <i class="fa-solid fa-circle-info text-[10px] ml-0.5"></i>
                        </button>
                        @if (pass.targetEvent?.eventDate) {
                          <span class="daisy-badge daisy-badge-sm daisy-badge-outline font-medium">
                            {{ pass.targetEvent?.eventDate | date: 'mediumDate' }}
                          </span>
                        }
                      } @else if (isSingleEventSubscriber()) {
                        <span class="daisy-badge daisy-badge-sm daisy-badge-warning daisy-badge-outline font-semibold gap-1">
                          <i class="fa-solid fa-lock text-xs"></i>
                          Not in Your Pass
                        </span>
                        @if (isFreeMeeting(item)) {
                          <span class="daisy-badge daisy-badge-sm daisy-badge-ghost font-medium">Free</span>
                        }
                        <button
                          type="button"
                          (click)="subscribeNow()"
                          class="daisy-btn daisy-btn-primary daisy-btn-xs gap-1 shadow-sm ml-auto"
                        >
                          <i class="fa-solid fa-ticket"></i>
                          <span>{{ isFreeMeeting(item) ? 'Get Free Pass' : 'Get Pass' }}</span>
                        </button>
                      } @else if (item.price === 0) {
                        <span class="daisy-badge daisy-badge-sm daisy-badge-success font-bold text-success-content">Free Event</span>
                      } @else if (item.price != null && item.price > 0) {
                        <span class="daisy-badge daisy-badge-sm daisy-badge-outline font-medium">LKR {{ item.price }} / session</span>
                      }
                    </div>
                    <div class="flex flex-wrap gap-4 mb-3">
                      <div class="flex items-center gap-2 text-base-content/70">
                        <i class="fa-solid fa-repeat text-sm text-base-content/60"></i>
                        <span class="font-medium">{{
                          getMeetingInterval(
                            item,
                            selectedLiveClass.details.startDate,
                            selectedLiveClass.details.endDate
                          )
                        }}</span>
                      </div>
                      <div class="flex items-center gap-2 text-base-content/70">
                        <i class="fa-solid fa-clock text-sm text-base-content/60"></i>
                        <span class="font-medium">
                          {{
                            getStartDate(
                              item,
                              selectedLiveClass.details.startDate,
                              selectedLiveClass.details.endDate
                            )[0] | date: 'shortTime'
                          }}
                          -
                          {{
                            getStartDate(
                              item,
                              selectedLiveClass.details.startDate,
                              selectedLiveClass.details.endDate
                            )[1] | date: 'shortTime'
                          }}
                        </span>
                      </div>
                    </div>
                    <p class="text-base-content/70 leading-relaxed">
                      {{
                        getMeetingDescription(
                          item,
                          selectedLiveClass.details.startDate,
                          selectedLiveClass.details.endDate
                        )
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            }
          </div>
        </section>

        <!-- Instructor Section -->
        <section class="scroll-mt-24" id="instructor">
          <div class="flex items-center gap-3 mb-4">
            <div class="w-1 h-8 bg-info rounded-full"></div>
            <h2 class="text-2xl md:text-3xl font-bold text-base-content">
              Your Instructor
            </h2>
          </div>
          <div
            class="daisy-card daisy-card-bordered bg-base-100 shadow-lg hover:shadow-xl transition-shadow duration-300"
          >
            <div class="daisy-card-body p-6">
              <black-user-info-card [user]="instructor"></black-user-info-card>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- Spacer Column -->
    <div class="w-full lg:w-2/5 px-4"></div>
  </div>

  <!-- Pass Details Modal -->
  <dialog
    class="daisy-modal"
    [class.daisy-modal-open]="isPassModalOpen"
    id="class_details_pass_modal"
  >
    <div class="daisy-modal-box max-w-md bg-base-100 text-base-content border border-base-300 shadow-2xl p-6">
      <div class="flex items-center gap-3 pb-3 border-b border-base-300">
        <div class="w-10 h-10 rounded-full bg-success/10 flex items-center justify-center text-success shrink-0">
          <i class="fa-solid fa-ticket text-lg"></i>
        </div>
        <div class="flex-1">
          <h3 class="font-bold text-lg text-base-content">Single Class Pass</h3>
          <p class="text-xs text-success font-medium">Verified & Active</p>
        </div>
      </div>

      <div class="py-4 space-y-3.5 text-sm">
        <div class="p-3.5 rounded-lg bg-base-200/60 border border-base-300 space-y-2 text-xs">
          <div class="flex items-center justify-between">
            <span class="text-base-content/60 font-medium">Course:</span>
            <span class="font-bold text-base-content">{{ selectedPassDetails?.liveClassName }}</span>
          </div>
          <div class="flex items-center justify-between">
            <span class="text-base-content/60 font-medium">Session Name:</span>
            <span class="font-bold text-primary">{{ selectedPassDetails?.meetingName }}</span>
          </div>
          @if (selectedPassDetails?.targetEventDate) {
            <div class="flex items-center justify-between">
              <span class="text-base-content/60 font-medium">Session Date:</span>
              <span class="font-semibold text-base-content">{{ selectedPassDetails?.targetEventDate | date: 'fullDate' }}</span>
            </div>
          }
          @if (selectedPassDetails?.startTime) {
            <div class="flex items-center justify-between">
              <span class="text-base-content/60 font-medium">Scheduled Time:</span>
              <span class="font-semibold text-base-content">
                {{ selectedPassDetails?.startTime }}
                @if (selectedPassDetails?.endTime) {
                  – {{ selectedPassDetails?.endTime }}
                }
              </span>
            </div>
          }
        </div>

        <p class="text-xs text-base-content/70 leading-relaxed">
          This pass grants you full access to participate in this specific class session, including live interactive video and materials.
        </p>

        <div class="daisy-alert bg-primary/5 border border-primary/20 text-xs py-2.5 px-3 flex items-start gap-2.5">
          <i class="fa-solid fa-lightbulb text-primary mt-0.5"></i>
          <span class="text-base-content/80 leading-relaxed">
            Upgrade anytime to the full course package and your single pass payment will be credited automatically.
          </span>
        </div>
      </div>

      <div class="daisy-modal-action flex flex-wrap gap-2 pt-2">
        <button
          type="button"
          (click)="closePassModal()"
          class="daisy-btn daisy-btn-ghost daisy-btn-sm"
        >
          Close
        </button>
        <button
          type="button"
          (click)="continueLearning()"
          class="daisy-btn daisy-btn-primary daisy-btn-sm gap-1.5 shadow-sm"
        >
          <i class="fa-solid fa-graduation-cap"></i>
          <span>Go to Class</span>
        </button>
      </div>
    </div>
    <form method="dialog" class="daisy-modal-backdrop">
      <button (click)="closePassModal()">close</button>
    </form>
  </dialog>
</div>
}
